import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  const isLoggedIn = Boolean(token);
  const location = useLocation();

  // Allow anyone to access the Feedback page
  if (!isLoggedIn && location.pathname === '/feedback') {
    return children;
  }

  // If not logged in, redirect to Entry
  if (!isLoggedIn) {
    return <Navigate to="/entry" replace />;
  }

  // Deny access only to FREE_USER or GUEST
  if (role === 'FREE_USER' || role === 'GUEST') {
    return <Navigate to="/membership" replace />;
  }

  return children;
};

export default PrivateRoute;
